import React from 'react';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS, Template} from '@chekin/core';
import {API} from '@chekin/api';
import {useEvent} from '@chekinapp/ui';

type UseFetchTemplateProps = {
  onSuccess?: (data: Template) => void;
  templateId?: string | null;
  enabled?: boolean;
};
function useFetchTemplate({
  onSuccess,
  templateId,
  enabled = true,
}: UseFetchTemplateProps) {
  const handleSuccess = useEvent(onSuccess);

  const query = useQuery<Template, Error>({
    queryKey: [QUERY_CACHE_KEYS.template, templateId],
    queryFn: () => API.theme.getCustomTheme(templateId!),
    refetchOnWindowFocus: false,
    enabled: Boolean(templateId) && enabled,
  });

  React.useEffect(() => {
    if (query.data) {
      handleSuccess(query.data);
    }
  }, [query.data, handleSuccess]);

  return query;
}

export {useFetchTemplate};
